<script lang="ts">
	import { browser } from '$app/env';
	import { copyToClipboard } from '#lib/helper/copyCliboard.js';
	import { t } from '#lib/stores/i18n.js';
	import { toastSuccess } from '#lib/stores/toast.js';
	import { Copy } from '@lucide/svelte';
	import type { Snippet } from 'svelte';

	interface Props {
		text?: string;
		getText?: () => string;
		title?: string;
		class?: string;
		toastMessage?: string;
		children?: Snippet;
	}

	let {
		text,
		getText,
		title = undefined,
		class: className = '',
		toastMessage = undefined,
		children
	}: Props = $props();
	let copyCodeElement: HTMLElement | undefined = $state();

	async function handleCopy(e: MouseEvent) {
		e.preventDefault();
		e.stopPropagation();

		const contentToCopy = getText ? getText() : text;
		if (!contentToCopy) return;

		try {
			if (browser) {
				await navigator.clipboard.writeText(contentToCopy);
			} else if (copyCodeElement) {
				copyToClipboard(copyCodeElement);
			}
			toastSuccess(toastMessage ?? $t('clipboard.copied'));
		} catch {
			if (copyCodeElement) {
				copyToClipboard(copyCodeElement);
				toastSuccess(toastMessage ?? $t('clipboard.copied'));
			}
		}
	}
</script>

<button
	type="button"
	onclick={handleCopy}
	title={title ?? $t('promoCode.action.copy')}
	class="relative inline-flex items-center justify-center gap-1.5 shrink-0 opacity-70 hover:opacity-100 dark:opacity-80 dark:hover:opacity-100 transition-opacity cursor-pointer {className}"
	disabled={!text && !getText}
>
	<Copy class="w-3.5 h-3.5 flex-none" strokeWidth="1.75" />
	{#if children}
		{@render children()}
	{/if}
	<span class="sr-only pointer-events-none" bind:this={copyCodeElement}>
		{text}
	</span>
</button>
